import React, { useEffect, useState } from "react";
import { Breadcrumb, Input, Select, Tabs, Timeline } from "antd";
import {
  ActiveDotIcon,
  BackIcon,
  CloseIcon,
  DriverActiveIcon,
  DriverNonactiveIcon,
  InactiveDotIcon,
  InvitationExpiredIcon,
  InvitationOpenedIcon,
  InvitationSentIcon,
  NoImageLogo,
} from "../../../../asset";
import { t } from "i18next";
import style from "./DriverAdd.module.css";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import SecondaryButton from "../../../../component/button/SecondaryButton";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constant/routeConstant";
import { GROLOG_BASE_URL, GROLOG_URL } from "../../../../constant/apiConstant";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import { DetailDayOff, ValueMSS } from "../../../../component/page-components/detail";
import { useSelector } from "react-redux";
import Delete from "../../../../component/modal/ModalDelete";
import ModalPhoto from "../../../../component/modal/ModalPhoto";
import CustomDivider from "../../../../component/divider/CustomDivider";
import { convertToArrData } from "../../../../util/Util";

const DriverDetail = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const navigate = useNavigate();
  const [detail, setDetail] = useState([]);
  const [userManagementOpen, setUserManagementOpen] = useState(false);
  const [managementHistoryList, setManagementHistoryList] = useState([]);
  const location = useLocation();
  const [showDelete, setShowDelete] = useState(false);
  const [isOpenPhoto, setIsOpenPhoto] = useState(false);
  const [isOpenPhoto2, setIsOpenPhoto2] = useState(false);
  const api = GROLOG_URL;
  const { permission } = useSelector((state) => state.auth);

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doGetBaseUrl = async (
    endpoint,
    tkn,
    params,
    dispatch,
    refresh_token
  ) => {
    const url = GROLOG_BASE_URL + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const fetchData = async () => {
    let res = await doGet(`/driver/${location.state}`, token);
    setDetail(res?.data?.payload?.data);
  };

  useEffect(() => {
    fetchData();
    getManagementHistoryList();
  }, []);

  const getManagementHistoryList = async () => {
    let res = await doGetBaseUrl(
      `audit/v1/grolog/audit?page=1&filter=table_name eq driver, primary_key eq ${location.state}`
    );

    const data = res?.data?.payload;
    const reorderedData = [];

    for (let i = data.length - 1; i >= 0; i--) {
      const element = data[i];
      reorderedData.push(element);
    }

    setManagementHistoryList(reorderedData);
  };

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const monthNumbers = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
      return `${dateFormat.getDate()}-${
        monthNames[dateFormat.getMonth()]
      }-${dateFormat.getFullYear()}`;
    } else {
      return `${dateFormat.getDate()}/${
        monthNumbers[dateFormat.getMonth()]
      }/${dateFormat.getFullYear()}`;
    }
  };

  const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return time.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  const backToUserList = () => {
    navigate(ROUTES.DRIVER.LIST);
  };

  const DriverProfile = () => {
    return (
      <>
        <div className="flex flex-col gap-[40px]">
          <div>
            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
              {t("DRIVER:DRIVER_INFO")}
            </h3> */}
            <CustomDivider name={"Driver Information"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:PHOTO")}
                  </label>
                  <div className="aspect-square cursor-pointer border-[3px] w-[144px] text-[#424242] border-gray-100 p-6 rounded-xl">
                    <img
                      onClick={() => setIsOpenPhoto(true)}
                      className="aspect-square"
                      src={
                        detail?.driver_photo
                          ? detail?.driver_photo
                          : NoImageLogo
                      }
                      alt="photos"
                    />
                  </div>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:NIK")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.nik ?  detail?.nik : "-"}
                  </h4>
                </div>

                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:GENDER")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.gender === "L"
                      ? "Laki-Laki"
                      : detail?.gender === "P"
                      ? "Perempuan"
                      : "-"}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:MARITAL_STATUS")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.marital_status ? detail?.marital_status : "-"}
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[16px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Username")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.username ? detail?.username : "-"}
                  </h4>
                </div>

                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:TITLE")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.title}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:LAST_NAME")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.last_name}
                  </h4>
                </div>

                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:BIRTH_DATE")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.birth_date}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:PHONE")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.phone}
                  </h4>
                </div>
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[16px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:DRIVER_ID")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.driver_id}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:FIRST_NAME")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.first_name}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:EMAIL")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.email}
                  </h4>
                </div>
              </div>
            </div>
          </div>

          {/* address info */}
          <div>
            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-[-30px]">
              {t("DRIVER:ADDRESS_INFO")}
            </h3> */}
            <CustomDivider name={t("DRIVER:ADDRESS_INFO")} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:COUNTRY")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.country}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:DISTRICT")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.district}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:ADDRESS")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.address}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:LONGITUDE")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.longitude ? detail?.longitude :"-"}
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[16px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:ISLAND")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.island}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:SUB_DISTRICT")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.sub_district}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:NEIGHBOURHOOD")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.neighbourhood ? detail?.neighbourhood : "-"}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:LATITUDE")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.latitude ? detail?.latitude : "-"}
                  </h4>
                </div>
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[16px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:PROVINCE")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.province}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:URBAN_VILLAGE")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.urban_village}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:HAMLET")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.hamlet ? detail?.hamlet : "-"}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:POSTAL_CODE")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.postal_code}
                  </h4>
                </div>
              </div>
            </div>
          </div>

          {/* Emergency contact */}
          <div>
            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
              {t("DRIVER:EMERGENCY_CONTACT")}
            </h3> */}
            <CustomDivider name={t("DRIVER:EMERGENCY_CONTACT")} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:NAME")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.emergency_contact_name}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:ADDRESS")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.emergency_contact_address}
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[16px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:RELATIONSHIP")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.emergency_contact_relationship}
                  </h4>
                </div>
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[16px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:PHONE")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.emergency_contact_phone}
                  </h4>
                </div>
              </div>
            </div>
          </div>

          {/* Driver Access */}
          <div>
            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-[-30px]">
              {t("Driver Access")}
            </h3> */}
            <CustomDivider name={t("Driver Access")} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Role")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.role_name ? detail?.role_name : "-"}
                  </h4>
                </div>
              </div>
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Data Group")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.data_group_name ? detail?.data_group_name : "-"}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const formatRupiah = (money) => {
    return new Intl.NumberFormat(
      "id-ID" // diletakkan dalam object
    ).format(money);
  };

  const JobDesc = () => {
    console.log("day off", detail?.day_off);
    return (
      <>
        <div className="flex flex-col gap-[40px]">
          <div>
            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-[30px]">
              {t("DRIVER:DRIVER_INFO")}
            </h3> */}
            <CustomDivider name={t("DRIVER:DRIVER_INFO")} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:EMPLOYMENT_STATUS")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.employment_status}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:SHIFT_START")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.shift_start}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:DAILY_SALARY")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    IDR {formatRupiah(detail?.salary)}
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[16px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:REGISTER_DATE")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.register_date}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:SHIFT_END")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.shift_end}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:HOUR_SALARY")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    IDR {formatRupiah(detail?.salary_per_hour)}
                  </h4>
                </div>
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[16px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:RESIGN_DATE")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">-</h4>
                </div>
                <div className="w-[350px] mb-[24px] h-20">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:DAY_OFF")}
                  </label>
                  {/* <div className="font-roboto w-[480px] h-[70px] text-[20px] text-[#424242] justify-start flex-wrap flex"> */}
                    
            <ValueMSS data={convertToArrData(detail?.day_off)} />
                    {/* {detail?.day_off?.split(",")?.map((el, index) => {
                      return (
                        <>
                          <div
                            key={index}
                            className="bg-red-200 px-2 rounded-3xl mr-2 mb-1"
                          >
                            <p className=" font-roboto-medium text-lg font-normal text-white-100">
                              {" "}
                              {el}{" "}
                            </p>
                          </div>
                        </>
                      );
                    })} */}
                    {/* <DetailDayOff
              data={detail?.day_off? [detail?.day_off] : null}
            /> */}
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
          <div>
            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-[-30px]">
              {t("DRIVER:VEHICLE_AND_DRIVING_LICENSE")}
            </h3> */}
            <CustomDivider name={t("DRIVER:VEHICLE_AND_DRIVING_LICENSE")} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:DRIVING_LICENSE_PHOTO")}
                  </label>
                  <div className="aspect-square border-[3px] w-44 text-[#424242] border-gray-100 p-6 rounded-xl">
                    <img
                      onClick={() => setIsOpenPhoto2(true)}
                      className="aspect-square"
                      src={
                        detail?.driving_license_photo
                          ? detail?.driving_license_photo
                          : NoImageLogo
                      }
                      alt="photoh"
                    />
                  </div>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[16px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:VEHICLE")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.vehicle_id} - {detail?.vehicle_type} -{" "}
                    {detail?.vehicle_plate
                      ?.replace("-", " ")
                      ?.replace("-", " ")}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:DRIVING_LICENSE_TYPE")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.driving_license_type}
                  </h4>
                </div>
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[16px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:VALIDITY_PERIOD")} of Driving License
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.validity_period_driving_license}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("DRIVER:DRIVING_LICENSE_NUMBER")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.driving_license_number}
                  </h4>
                </div>
              </div>
            </div>
          </div>
          {/* additional */}
          <div>
            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-[30px]">
              {t("Additional Proofs")}
            </h3> */}
            <CustomDivider name={t("Additional Proofs")} />
            <div className={style.gridContainer} style={{ display: "grid" }}>
              {/* line one */}
              {detail?.additional_proofs?.map((el) => {
                return (
                  <>
                    <div
                      // className="gap-[40px] mb-[24px] "
                      className={style.gridItem}
                    >
                      <div className="w-[350px] mb-[24px]">
                        <label className="font-roboto text-[14px] text-[#818181]">
                          {el?.key}
                        </label>
                        <h4 className="font-roboto text-[20px] text-[#424242]">
                          {el?.value ? el.value : "-"}
                        </h4>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        </div>
      </>
    );
  };

  const items = [
    {
      key: 1,
      label: t("DRIVER:DRIVER_PROFILE"),
      children: DriverProfile(),
    },
    {
      key: 2,
      label: t("DRIVER:JOB_DESC"),
      children: JobDesc(),
    },
  ];
  return (
    <>
      <ModalPhoto
        photo={detail?.driver_photo}
        show={isOpenPhoto}
        onClose={() => setIsOpenPhoto(false)}
      />
      <ModalPhoto
        photo={detail?.driving_license_photo}
        show={isOpenPhoto2}
        onClose={() => setIsOpenPhoto2(false)}
      />
      <Delete
        data={detail.updated_at}
        id={detail.driver_id}
        delete={showDelete}
        title={detail.first_name}
        url={"driver"}
        action={() => setShowDelete(false)}
        route={ROUTES.DRIVER.LIST}
        token={token}
        param={param}
        // refresh={fetchData()}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Master`}
          menuLevel2={`Fleet`}
          menuLevel3={`Driver`}
          menuLevel4={`Detail Driver`}
        />

        <div className="flex items-center justify-between">
          <div
            className="flex items-center gap-[22px] cursor-pointer"
            onClick={() => backToUserList()}
          >
            <img src={BackIcon} alt="" />
            <h1 className="font-sans-bold text-2xl" id="title">
              Detail {detail?.driver_id} - {detail?.first_name}{" "}
              {detail?.last_name}
            </h1>
            <img src={detail.status ==="Invitation Expired" ? InvitationExpiredIcon : detail.status ==="Invitation Sent" ? InvitationSentIcon : detail.status === "Non-Active" ? DriverNonactiveIcon : detail.status === "Active" ? DriverActiveIcon : detail.status ==="Invitation Opened" ? InvitationOpenedIcon :""} alt="-"/>
          </div>
          <div
            className="bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer"
            onClick={() => setUserManagementOpen(true)}
          >
            <p className="text-[#666666]">
              {t("USER_DETAIL:CREATED_BY")}{" "}
              <strong>{detail?.created_by}</strong> {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(detail?.created_at, true)}</strong> |{" "}
              {t("USER_DETAIL:LAST_MODIFIED_BY")}{" "}
              <strong>{detail?.updated_by}</strong> {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(detail?.updated_at, true)}</strong>
            </p>
          </div>
        </div>
        {/* <DataManagementHistory/> */}

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            <Tabs
              defaultActiveKey="1"
              items={items}
              className="border-b border-[#ffffff]"
            />
          </div>
        </div>

        <div className="flex flex-row-reverse gap-[16px]">
          <PrimaryButton
            actions="update"
            menu="driver"
            parent="master"
            text={t("DRIVER:EDIT")}
            action={() =>
              navigate(ROUTES.DRIVER.EDIT, { state: detail.driver_id })
            }
          />
          <SecondaryButton
            actions="delete"
            menu="driver"
            parent="master"
            text={t("DRIVER:DELETE")}
            action={() => setShowDelete(true)}
          />
        </div>

        <aside
          className={
            userManagementOpen
              ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"
              : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"
          }
        >
          <button
            className="absolute top-[21px] right-[21px]"
            onClick={() => setUserManagementOpen(false)}
          >
            <img src={CloseIcon} alt="" />
          </button>

          <h3 className="font-sans font-[600] text-[#1D1D1D] text-[20px]">
            {t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}
          </h3>
          <p className="font-sans font-[400] text-[#818181] text-[12px] mb-[24px]">
            {t("USER_DETAIL:CREATED_BY")} <strong>{detail?.created_by}</strong>{" "}
            {t("USER_DETAIL:ON")}{" "}
            <strong>{convertTimestamp(detail?.created_at)}</strong>
          </p>

          <div className={style.timelineContainer}>
            <Timeline>
              {managementHistoryList.map((item, index) => {
                if (index === 0) {
                  return (
                    <Timeline.Item dot={<img src={ActiveDotIcon} />}>
                      <div className="flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]">
                        <h4 className={"text-[#CF0000] font-[500] text-[14px]"}>
                          {t("USER_DETAIL:LAST_MODIFIED")}
                        </h4>
                        <h4 className="font-[500] text-[14px] text-[#424242]">
                          {item.alias_name}
                        </h4>
                        <p className="font-[400] text-[14px]">{`${convertTimestamp(
                          item.created_at
                        )} • ${convertToTime(item.created_at)}`}</p>
                      </div>
                    </Timeline.Item>
                  );
                } else {
                  return (
                    <Timeline.Item dot={<img src={InactiveDotIcon} />}>
                      <div className="flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]">
                        <h4 className={"font-[500]"}>
                          {t("USER_DETAIL:MODIFIED")}
                        </h4>
                        <h4 className="font-[500] text-[14px] text-[#424242]">
                          {item.alias_name}
                        </h4>
                        <p className="font-[400] text-[14px]">{`${convertTimestamp(
                          item.created_at
                        )} • ${convertToTime(item.created_at)}`}</p>
                      </div>
                    </Timeline.Item>
                  );
                }
              })}
            </Timeline>
          </div>
        </aside>
      </div>
    </>
  );
};
export default DriverDetail;
